import { useQuery } from '@tanstack/react-query';
import { getProjectSummary } from '../api/project-dashboard-api';

export const projectDashboardKeys = {
  all: ['project-dashboard'] as const,
  summary: (projectId: number) => [...projectDashboardKeys.all, 'summary', projectId] as const,
};

export const useProjectSummary = (projectId: number | undefined) =>
  useQuery({
    queryKey: projectDashboardKeys.summary(projectId ?? 0),
    queryFn: () => getProjectSummary(projectId!),
    enabled: Boolean(projectId),
    staleTime: 60_000,
  });
